import { Languages } from "lucide-react";
import { useT, LANGUAGES } from "@/lib/i18n";

/**
 * Compact pill toggle between English + Kannada.
 * Uses `data-testid` values `lang-toggle-en` and `lang-toggle-kn` for e2e tests.
 */
const LanguageSwitch = ({ compact = false, className = "" }) => {
  const { lang, setLang, t } = useT();
  return (
    <div
      role="group"
      aria-label={t("lang.label")}
      data-testid="lang-switch"
      className={`inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white/80 backdrop-blur px-1 py-1 ${className}`}
    >
      {!compact && <Languages className="h-4 w-4 text-slate-500 ml-1.5" />}
      {LANGUAGES.map((l) => {
        const active = lang === l.code;
        return (
          <button
            key={l.code}
            data-testid={`lang-toggle-${l.code}`}
            aria-pressed={active}
            onClick={() => setLang(l.code)}
            className={`text-xs font-display font-semibold px-3 py-1 rounded-full transition ${
              active
                ? "bg-ark-sky text-white shadow-sm"
                : "text-slate-600 hover:text-ark-skyDeep"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitch;
